module.exports = __webpack_public_path__ + "static/media/tutorial-02.71303700.jpg";